const INITIAL_STATE = {
  table: [],
  modulesAmount: 0,
};
export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'ModulesTable':
      return {
        ...state,
        ...payload,

      };
    default:
  }
  return { ...state };
};
